import {
	Dispatch, FC, SetStateAction, useMemo,
} from 'react';
import {
	Breadcrumbs,
	Grid, HomeIcon,
	SegmentedBar,
	ToggleButton,
	Wizard,
} from '@aleph/shared-components';
import { useSupergridMutations, SuperGridMutatorMode } from '@aleph/supergrid';
import { SpotifySuperGridMutationsConfig } from 'wb-spotify/app/routes/superGrid/mutator/utils';
import { SPOTIFY_SUPERGRID_CONFIG } from 'wb-spotify/app/routes/superGrid/config';
import { SpotifyLevel } from 'wb-spotify/app/routes/superGrid/utils';
import useSaveBeforeExitDialog from 'wb-reddit/app/routes/hooks/useSaveBeforeExitDialog';

type MutatorActionRowContainerProps = {
	selectedMode: SuperGridMutatorMode
	setSelectedMode: Dispatch<SetStateAction<SuperGridMutatorMode>>
};

const SpotifyMutatorActionRowContainer: FC<MutatorActionRowContainerProps> = ({
	selectedMode,
	setSelectedMode,
}) => {
	const {
		mutations: storeMutations,
		getMutationsWithParents,
		clearMutations,
	} = useSupergridMutations<SpotifySuperGridMutationsConfig>();

	const mutations = useMemo(() => getMutationsWithParents(SPOTIFY_SUPERGRID_CONFIG), [storeMutations]);

	const {
		dialog: saveBeforeExitModal,
		beforeClose,
	} = useSaveBeforeExitDialog({
		onConfirm:                  clearMutations,
		defaultShouldPromptOnClose: true,
	});

	return (
		<div className="flex items-center justify-between py-2 border-b h-[65px]"
			data-testid="supergrid-header-container"
		>
			<div className="flex gap-[8px] items-center text-[16px]">
				<ToggleButton
					data-testid="go-home-button"
					onClick={beforeClose}
					leadingIcon={<HomeIcon />}
				/>

				<Breadcrumbs
					breadcrumbs={[{
						id:    mutations[SpotifyLevel.CAMPAIGN]?.[0]?.parent?.name ?? 'Client',
						level: SpotifyLevel.CAMPAIGN,
						name:  mutations[SpotifyLevel.CAMPAIGN]?.[0]?.parent?.name ?? 'Client',
					}]}
				/>
			</div>
			<SegmentedBar>
				<SegmentedBar.Button
					leadingIcon={<Wizard />}
					active={selectedMode === SuperGridMutatorMode.VERTICAL}
					onClick={() => setSelectedMode(SuperGridMutatorMode.VERTICAL)}
					data-testid="wizard-button"
				>
					Wizard
				</SegmentedBar.Button>
				<SegmentedBar.Button
					leadingIcon={<Grid />}
					active={selectedMode === SuperGridMutatorMode.HORIZONTAL}
					onClick={() => setSelectedMode(SuperGridMutatorMode.HORIZONTAL)}
					data-testid="table-button"
				>
					Table
				</SegmentedBar.Button>
			</SegmentedBar>

			{saveBeforeExitModal}
		</div>
	);
};

export default SpotifyMutatorActionRowContainer;
